import type {RichTextDocument} from "@o2d/rich-text-editor";

/**
 * Pure helper for the RTE-document consumers (`knowledge-rte.component.ts`,
 * `ha-dialog-rte-view.component.ts` — the latter mirrors the former's own
 * load-guard, see its doc comment). Kept in one place so both stay in sync
 * (Anke, 2026-09-05: "alles andere genauso wie beim richtigen whiteboard") —
 * previously a private static method duplicated inline on `KnowledgeRte`.
 */
export class RichTextDocumentHelper {

    /**
     * Type-guard: a persisted `content.payload` is a usable `RichTextDocument`
     * only when it is a plain object with `type: 'doc'`. Guards against the
     * empty-array (`[]`) payload the backend create handler seeds for a fresh
     * object of ANY `KnowledgeObjectType` (the entity's `content.payload` field
     * is untyped/shared across whiteboard's genuinely-array payload and a
     * document's single-object payload), and any legacy whiteboard-shaped array.
     */
    public static isRichTextDocument(value: unknown): value is RichTextDocument {
        return typeof value === 'object'
            && value !== null
            && !Array.isArray(value)
            && (value as { type?: unknown }).type === 'doc';
    }

}
